export var MuiTableHead = {
    root: {},
};
//# sourceMappingURL=MuiTableHead.js.map